<template>
  <pt-trust-deed-form class="pt-trust-deed-excel-form__page"></pt-trust-deed-form>
</template>

<script>
import PtTrustDeedForm from 'cps/trust-deed/pt-trust-deed-form/withData'
export default {
  name: 'pt-trust-deed-form__view',
  components: {
    'pt-trust-deed-form': PtTrustDeedForm
  }
}
</script>
